import styled from "@emotion/styled"

const Container = styled.div(() => ({
  display: "flex",
  flexGrow: 1,
}))

export default Container
